// 集中词表：zh / en 仍留在各组件内，这里只放新增语言。
// 结构为 { <locale>: { <组件 name>: { key: text } } }

import pt from "./locales/pt";
import ru from "./locales/ru";
import tw from "./locales/tw";
import ro from "./locales/ro";
import es from "./locales/es";
import sk from "./locales/sk";
import it from "./locales/it";
import de from "./locales/de";
import ja from "./locales/ja";
import cs from "./locales/cs";

export default { pt, ru, tw, ro, es, sk, it, de, ja, cs };
